import { inject, injectable } from 'inversify'

import { RoutingService } from '#AltServices'

@injectable()
export class LoyaltyRoutingService {
  constructor(@inject(RoutingService) readonly router: RoutingService) {}

  get index() {
    return this.router.createRouteData({ name: 'LoyaltyIndex' })
  }
}
